import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';
import PropTypes from 'prop-types';
import React from 'react';


HighchartsNoData(Highcharts);

/**
 *
 * @param {Highcharts.Options} data
 * @param {string} title
 * @param {Highcharts.Options} options
 * @returns {Highcharts.Options}
 */
export const createAreaChart = (data, title, options) => ({
  title: {
    text: title,
    style: {
      fontSize: '1em'
    }
  },
  series: data,
  chart: {
    type: 'area',
    height: '80%'
  },
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '15px',
      color: '#303030'
    }
  },
  credits: {
    enabled: false
  },
  ...options,
});

const Area = ({
  data,
  title,
  options
}) => {
  const chartsOptions = createAreaChart(data, title, options);

  return (<HighchartsReact
    highcharts={Highcharts}
    options={chartsOptions}
    containerProps={{ className: 'border border-dark border-radius-1' }}
  />);
};

Area.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.any)
    })
  ).isRequired,
  title: PropTypes.string,
  options: PropTypes.object
};

Area.defaultProps = {
  options: {},
  title: null
};
export default Area;